exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".limiter1 {\n  max-height: 500px;\n  overflow: auto;\n  overflow-x: hidden; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/location/command-window/command-window.component.scss
// module id = ../../../../../src/app/location/command-window/command-window.component.scss
// module chunks = main